import { v4 as uuidv4 } from "uuid";
export class AutomationModel {
    constructor() {
        this.id = uuidv4();
        this.title = "";
        this.recurrenceRule = "";
        this.createdOnAsString = "";
        this.savedSearch = "";
        this.users = [];
        this.organizationId = "";
        this.organizationName = "";
        this.savedSearchId = uuidv4();
        this.recurrenceRuleId = uuidv4();
        this.isSaveSearchClickable = false;
        this.isArchived = false;
        this.recurrenceStartDateAsString = "";
    }
}
export default class Automation extends AutomationModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
